import React from "react";
import Button from "react-bootstrap/Button";
import NavBar from "./reusable-components/nav-bar";
import Rectangle from '../images/Rectangle.png';
import Footer from "./reusable-components/footer";
import Device from "./device";
import { Link } from 'react-router-dom';
function DeviceRegistration() {
    return (
        <div style={{
            backgroundColor: '#F9F9F9'
        }}>
            <NavBar />
            <div >
                <img src={Rectangle} style={{ width: '100%', height: '66px' }} alt="" />
            </div>
            <div style={{
                backgroundColor: '#F9F9F9'
            }}>
                <Device />
            </div>
            <div style={{
                textAlign: 'center',
                backgroundColor: '#F9F9F9',
                marginTop: '20px',
                marginBottom: '20px'
            }}>
                <Link to="/Register">
                    <Button variant="success" size="lg" type="submit" style={{
                        height: '35px',
                        width: '185px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        borderRadius: '0',
                        color: '#FFFFFF',
                        backgroundColor: '#00A78A'
                    }} >
                        NEXT
                    </Button>
                </Link>
            </div>
            <Footer />
        </div>
    );
}
export default DeviceRegistration;